import { render, staticRenderFns } from "./ShowcaseType.vue?vue&type=template&id=4fd06dba&scoped=true"
import script from "./ShowcaseType.vue?vue&type=script&lang=ts"
export * from "./ShowcaseType.vue?vue&type=script&lang=ts"
import style0 from "./ShowcaseType.vue?vue&type=style&index=0&id=4fd06dba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd06dba",
  null
  
)

export default component.exports